(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-video-hover"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__tembladCardVideo) return;
    window.__tembladCardVideo = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const play = (video) => {
      const promise = video.play();
      if (promise) {
        promise.then(() => video.classList.add('is-playing')).catch(() => {});
      }
    };

    const stop = (video, reset) => {
      video.pause();
      video.classList.remove('is-playing');
      if (reset) video.currentTime = 0;
    };

    const videoIn = (gallery) => gallery && gallery.querySelector(':scope > .card-video-hover');

    if (canHover) {
      // Desktop: delegación de eventos, funciona también con filtros y scroll infinito
      document.addEventListener('pointerover', (event) => {
        const gallery = event.target.closest && event.target.closest('.card-gallery');
        const video = videoIn(gallery);
        if (video && !video.classList.contains('is-playing')) play(video);
      });

      document.addEventListener('pointerout', (event) => {
        const gallery = event.target.closest && event.target.closest('.card-gallery');
        if (!gallery || gallery.contains(event.relatedTarget)) return;
        const video = videoIn(gallery);
        if (video) stop(video, true);
      });
      return;
    }

    // Mobile: solo si el usuario no tiene activado el ahorro de datos
    const connection = navigator.connection;
    if (connection && connection.saveData) return;
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            play(entry.target);
          } else {
            stop(entry.target, false);
          }
        });
      },
      { threshold: [0, 0.6] }
    );

    const observeAll = () => {
      document
        .querySelectorAll('.card-video-hover[data-mobile-autoplay="true"]:not([data-observed])')
        .forEach((video) => {
          video.dataset.observed = 'true';
          observer.observe(video);
        });
    };

    observeAll();
    // Cuando se filtra o se cargan más productos, se observan las tarjetas nuevas
    new MutationObserver(observeAll).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
